import { api } from "@/lib/api";

import type {
  CreateStockReasonReq,
  PaginationQuery,
  GetStockCardReq,
  GetStockListReq,
  RiderStockSummary,
  StockCardRes,
  StockKpiMetrics,
  StockListRes,
  StockReason,
  UpdateStockReasonReq,
} from "@artisancode/api-types";

export const stockService = {
  list: (params?: Omit<GetStockListReq, "pagination"> & PaginationQuery) =>
    api.get<StockListRes>(
      "/stocks",
      params as unknown as Record<
        string,
        string | number | boolean | undefined
      >,
    ),

  metrics: (params?: { workspace_id?: string }) =>
    api.get<StockKpiMetrics>(
      "/stocks/metrics",
      params as Record<string, string | number | boolean | undefined>,
    ),

  card: (itemType: string, itemId: string, params?: Partial<GetStockCardReq>) =>
    api.get<StockCardRes>(
      `/stocks/${itemType}/${itemId}/card`,
      params as unknown as Record<
        string,
        string | number | boolean | undefined
      >,
    ),

  reasons: (params?: {
    direction?: string;
    is_active?: boolean;
    workspace_id?: string;
  }) =>
    api.get<StockReason[]>(
      "/stocks/reasons",
      params as Record<string, string | number | boolean | undefined>,
    ),

  createReason: (body: CreateStockReasonReq) =>
    api.post<StockReason>("/stocks/reasons", body),

  updateReason: (id: string, body: UpdateStockReasonReq) =>
    api.put<StockReason>(`/stocks/reasons/${id}`, body),

  riders: (params?: { workspace_id?: string }) =>
    api.get<RiderStockSummary[]>(
      "/stocks/riders",
      params as Record<string, string | number | boolean | undefined>,
    ),
};
